import styled from 'styled-components';
type Props = {};

export default styled.section<Props>`
  #privacy-policy .privacy-policy-title {
    margin-bottom: 25px;
    text-align: center;
    font-size: 2rem;
    letter-spacing: 0.2em;
  }
  #privacy-policy .section-title {
    margin-bottom: 15px;
    padding: 7px 0 6px;
    background-color: #eee;
    text-align: center;
    /*  font-size: 1.4rem; */
  }
  #privacy-policy .inner {
    padding: 15px 17px;
    border: 1px solid #ddd;
  }
  #privacy-policy .size-xlarge {
    font-size: 2.2rem;
  }
  #privacy-policy .size-large {
    font-size: 1.5rem;
  }
  #privacy-policy .size-large .size-default {
    font-size: 1.3rem;
  }
`;
export const SitesChargeStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
